export default {
  loader: {
    none: 'Aucun résultat',
    end: 'Fin de la liste'
  },
  menu: {
    login: 'Connexion',
    signup: 'Inscription',
    username: 'Pseudo',
    password: 'Mot de passe',
    confirmation: 'Confirmation',
    mail: 'E-mail',
    location: 'Pays/Ville',
    language: 'Langue',
    english: 'Anglais',
    french: 'Français',
    birthday: 'Date de naissance',
    ok: 'OK',
    validate: 'Valider'
  },
  categories: {
    news: 'Actualités',
    reviews: 'Chroniques',
    interviews: 'Interviews',
    releases: 'À découvrir',
    events: 'Événements',
    encyclopedia: 'Encyclopédie',
    forums: 'Forums'
  },
  reviews: {
    credits: 'Chronique par'
  },
  interviews: {
    credits: 'Interview par'
  },
  gigs: {
    title: 'Événement prochain',
    what: 'Quoi ?',
    where: 'Où ?',
    when: 'Quand ?',
    who: 'Qui ?',
    price: 'Tarif'
  },
  liveReports: {
    credits: 'Live-report par'
  },
  galleries: {
    credits: 'Galerie par'
  },
  events: {
    gigs: 'Concerts',
    liveReports: 'Live-reports',
    photos: 'Photos'
  },
  encyclopedia: {
    styles: 'Styles',
    bands: 'Groupes',
    artists: 'Artistes',
    albums: 'Albums',
    audios: 'Audios',
    videos: 'Vidéos',
    labels: 'Labels',
    places: 'Lieux',
    stats: 'Statistiques',
    search: 'Recherche...',
    info: 'À propos',
    sheet: 'Fiche descriptive',
    style: 'Style',
    band: 'Groupe',
    country: 'Pays',
    region: 'Région',
    city: 'Ville',
    date: 'Date',
    status: 'Statut',
    website: 'Site web'
  },
  style: {
    bands: 'Groupes phares',
    albums: 'Albums célèbres'
  },
  band: {
    creation: 'Formation',
    split: 'Séparation',
    popularity: 'Popularité',
    fans: 'Fans',
    lineup: 'Line-up',
    formerMembers: 'Anciens membres',
    discography: 'Discographie'
  },
  artist: {
    birth: 'Naissance',
    bands: 'Groupe associé | Groupes associés'
  },
  album: {
    type: 'Type',
    studio: 'Studio',
    producer: 'Producteur',
    label: 'Label | Labels',
    tracklist: 'Liste des morceaux',
    audio: 'Audio disponible | Audios disponibles'
  },
  label: {
    releases: 'Dernière sortie | Dernières sorties'
  },
  place: {
    description: 'Description',
    address: 'Adresse'
  },
  post: {
    on: 'Le',
    by: 'par'
  }
}



// WEBPACK FOOTER //
// ./src/locales/fr.js